import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { StorefrontLayout } from "@/components/storefront/Layout";
import { TrendingUp } from "lucide-react";
import { ProductListing } from "@/components/storefront/ProductListing";
import { PlayfulPageHeader } from "@/components/storefront/PlayfulPageHeader";
import { PlayfulError, PlayfulNotFound } from "@/components/storefront/PlayfulError";
import { listingSearchSchema } from "@/lib/listing-search";
import { ChristmasStrip } from "@/components/storefront/ChristmasStrip";

export const Route = createFileRoute("/best-sellers")({
  validateSearch: listingSearchSchema,
  head: () => ({
    meta: [
      { property: "og:url", content: "https://mrpanda.gr/best-sellers" },
      { title: "Κορυφαία σε πωλήσεις — MrPanda.gr" },
      { name: "description", content: "Δες τα κορυφαία προϊόντα σε πωλήσεις στο MrPanda.gr: τα πιο αγαπημένα προϊόντα των πελατών μας με τις καλύτερες τιμές και γρήγορη αποστολή." },
      { property: "og:title", content: "Κορυφαία σε πωλήσεις — MrPanda.gr" },
      { property: "og:description", content: "Τα πιο αγαπημένα και δημοφιλή προϊόντα των πελατών του MrPanda.gr." },
    ],
    links: [{ rel: "canonical", href: "https://mrpanda.gr/best-sellers" }],
  }),
  component: BestSellersPage,
  errorComponent: ({ error, reset }) => (
    <StorefrontLayout>
      <PlayfulError error={error instanceof Error ? error : new Error(String(error))} reset={reset} />
    </StorefrontLayout>
  ),
  notFoundComponent: () => (
    <StorefrontLayout>
      <PlayfulNotFound />
    </StorefrontLayout>
  ),
});

function BestSellersPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <StorefrontLayout>
      <div className="mx-auto max-w-none px-4 pb-10 pt-6">
        <PlayfulPageHeader
          icon={TrendingUp}
          title="Κορυφαία σε πωλήσεις"
          subtitle="Τα πιο αγαπημένα προϊόντα της παρέας του Mr Panda! 🐼"
          mascot="🏆"
          doodles={["🔥", "⭐", "🛒", "💛"]}
          gradient="bg-gradient-to-br from-amber-200/60 via-accent/40 to-background"
        />
        <ChristmasStrip className="px-0 pb-4 pt-0" />
        <ProductListing
          scope={{ mode: "best", cacheKey: "best" }}
          search={search}
          onChange={(next) => navigate({ search: (prev: typeof search) => ({ ...prev, ...next }), replace: true })}
        />
      </div>
    </StorefrontLayout>
  );
}